/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Text from '../components/ingka/Text'
import { useTranslation } from 'react-i18next'
import Select from "../components/global/Select"
import Button from '../components/ingka/Button'
import Table from '../components/global/Table'
import Load from '../components/ingka/Load'
import { ROL } from '../configuration/globalConstants'
import ConfirmationModal from '../components/global/ConfirmationModal';
import Switch from '../components/ingka/Switch';
import SSRIcon from '@ingka/ssr-icon'
import eye from '@ingka/ssr-icon/paths/visibility-show'
import { useSessionStore } from '../store/sessionStore'
import { useUserRoles } from '../hooks/use-user-roles'
import { useUserList } from '../hooks/use-user-list'
import { useUserUpdate } from '../hooks/use-user-update'
import { useUserSearch } from '../hooks/use-user-search'

export default function Users() {
  const [t] = useTranslation("global")
  const { roleOptions} = useUserRoles()
  const { users, reloadUsers } = useUserList()
  const [filteredAppUsers, setFilteredAppUsers] = useState(null)
  const [userSelected, setUserSelected] = useState(null)
  const [roleSelected, setRoleSelected] = useState(null)
  const[confirmation, setConfirmation] = useState(null)
  const { rol, myStore } = useSessionStore()
  const { userUpdate, isLoadingUserUpdate, isSuccessUserUpdate } = useUserUpdate()
  const [searchParams, setSearchParams] = useState(null);
  const { userSearch, isLoadingUserSearch } = useUserSearch(searchParams)

  const cellRole = ({row}) => {
    return <span>{row.original.roles[0]?.name}</span>
  }
  const cellStatus = ({row}) => {
    return <Switch
              props={{
                className: "zoom08",
                value: row.original.active,
                checked: row.original.active,
                onChange: e => handleActive(e.target.checked, row.original),
                disabled: (rol.id !== ROL.SUPERADMIN && rol.id !== ROL.ADMIN)
              }}
            />
  }
  const columns = [
    {accessorKey: "displayName", header: t('global.name')},
    {accessorKey: "mail", header: 'Email'},
    {accessorKey: "roles", header: t('global.rol'), Cell: cellRole },
    {accessorKey: "active", header: t('global.active'), Cell: cellStatus }
  ]

  const [buttonsView, setButtonsView] = useState([
    {
      text: t('users.viewMyStore'),
      mode: "myStore"
    }
  ])
  const [viewSelected, setViewSelected] = useState("all")

  const getUsersByMode = (usersList, mode) => {
      if (!usersList) return null

      return usersList.filter(user => {
          switch (mode) {
              case "all":
                  return true
              case "myStore":
                  return user.officeLocation === myStore.officeLocation
              default:
                  return user.roles[0].name === mode && (rol.id === ROL.SUPERADMIN || (rol.id === ROL.ADMIN && user.officeLocation === myStore.officeLocation))
          }
      })
  }

  useEffect(() => {
    if(roleOptions && users && buttonsView.length === 1){
      let buttons = [...buttonsView, ...roleOptions.map( rol => ({text: rol.label, mode: rol.label}))]
      if(rol.id === ROL.SUPERADMIN){
        buttons.unshift({
          text: t('users.viewAll'),
          mode: "all"
        })
      } else {
        setViewSelected("myStore")
      }
      setButtonsView(buttons)
    }
  }, [roleOptions, users])

    useEffect(() => {
        if (users) {
            setFilteredAppUsers(getUsersByMode(users, viewSelected))
        }
    }, [users, viewSelected, rol.id, myStore.officeLocation])

  const handleInputChange = (mail) => {
    if(mail.length > 3){
      setSearchParams({ mail: mail, expand: "id,mail" });
    }
  }

  const handleUserSelected = (user) => {
    setUserSelected(user)
    findUserSelected(user)
  }

  const findUserSelected = (user) => {
    setRoleSelected(null)
    const userInApp = users.find( userApp => userApp.mail === user.label)
    if(userInApp){
      setRoleSelected(roleOptions.filter( rol => rol.value === userInApp.roles[0].id))
    }
  }

  useEffect(() => {
    if(isSuccessUserUpdate){
      setFilteredAppUsers(null)
      reloadUsers()
      setSearchParams(null)
      setUserSelected(null)
      setRoleSelected(null)
    }
  }, [isSuccessUserUpdate])

  const handleActive = (checked, user) => {
    setConfirmation({
      title: t('users.changeActive'),
      msg: t('users.changeActiveMsg'),
      button: t('global.save'),
      action: () => userUpdate({
        userId:user.mail, 
        newRoleId: user.roles[0].id, 
        active: checked,
        successMsg: t("users.successUpdateActive")
      })
    })
  }

  const updateView = (mode) => {
    setViewSelected(mode)
  }

  return (
    <div className="container">
      <section className="container-header-button">
        <Text tagName="h2" headingSize="m">{t('users.title')}</Text>
      </section>

      <section>
        {rol.id === ROL.SUPERADMIN &&
          <div className="row" style={{ alignItems: "center" }}>
            <Select
              formField={{
                className: "col-lg-6 col-md-12 col-sm-12"
              }}
              label={t('users.searchUserByMail')}
              isSearchable={true}
              onInputChange={handleInputChange}
              onChange={handleUserSelected}
              isLoading={isLoadingUserSearch}
              dataId="user"
              options={userSearch}
            />
            <Select
              formField={{
                className: "col-lg-4 col-md-8 col-sm-12"
              }}
              label={t('users.selectRole')}
              onChange={val => setRoleSelected(val)}
              value={roleSelected}
              isDisabled={!userSelected}
              dataId="role"
              options={roleOptions}
            />
            <Button
              type="emphasised"
              text={t('global.save')}
              onClick={() => userUpdate({ 
                userId: userSelected.label, 
                newRoleId: roleSelected.value,
                successMsg: t("users.successUpdateRole")
              })}
              className="col-lg-2 col-md-4 col-sm-12"
              disabled={!userSelected && !roleSelected}
            />
          </div>
        }

        {isLoadingUserUpdate &&
          <Load />
        }
        {filteredAppUsers && !isLoadingUserUpdate &&
        <>
          <article style={{ display: "flex", alignItems: "center", margin: "1rem 0"}}>
            <SSRIcon paths={eye}/>
            <Text >{filteredAppUsers.length}</Text>
            {buttonsView.map( (btn, index) =>
              <Button
                key={btn.text + index}
                type="secondary"
                small
                className="ml-1"
                text={btn.text}
                onClick={() => updateView(btn.mode)}
                disabled={viewSelected === btn.mode}
              />
            )}
          </article>
          <Table
            columns={columns}
            data={filteredAppUsers}
            enableSorting={true}
            enablePagination={false}
          />
          </>
        }
      </section>
      <ConfirmationModal confirmation={confirmation} />
      
    </div>
  )
}
